import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link } from "react-router-dom";

import { v } from "../env/env_variable";

import { useStateValue } from "../utils/provider/StateProvider";
import { db, auth } from "../utils/db/Authorize";

// records:
import data from "./build/data/test.json";

import { signOut } from "firebase/auth";

function Header() {
  // REDUX STATES:
  const [{ user, searchText }, dispatch] = useStateValue();

  // state:
  const [sideMenu, setSideMenu] = useState(false);

  // Logout Function:
  const signUserOut = async () => {
    await signOut(auth);
    dispatch({
      type: "ADD_USER",
      user: null,
    });
  };

  return (
    <div>
      <div className="header_container">
        <div className="header_link_div">
          <div className="header_quick_link_main">
            <Link to="/" className="header_title_page">
              {v.PAGE_TITLE}
            </Link>
          </div>

          <div className="header_link_div">
            <Link to="/u/solarsystem">Solar System</Link>
            <Link to="/u/universe">Universe</Link>
          </div>
        </div>

        <div className="header_link_div hide_me">
          {user ? (
            <Link to="/" onClick={() => signUserOut()}>
              {user && user.displayName}, Logout
            </Link>
          ) : (
            <Link to="/u/login/" className="header_link_div_login">
              Login
            </Link>
          )}
        </div>

        <div className="header_drawer_btn" onClick={() => setSideMenu(true)}>
          menu
        </div>
      </div>

      {sideMenu && (
        <div className="header_drawer_main_container">
          <div
            className="drawer_left_panel"
            onClick={() => setSideMenu(false)}
          ></div>

          <div className="drawer_right_panel">
            <p className="drawer_title">
              Welcome to <span>{v.PAGE_TITLE}</span>
            </p>

            <p className="drawer_account_details">
              Logged as: {user ? user.displayName : "Guest"}
            </p>

            <hr />

            <div className="drawer_quick_links">
              <Link to="/u/global/accounts">Accounts</Link>

              {user && user ? (
                <Link to="/" onClick={() => signUserOut()}>
                  Logout
                </Link>
              ) : (
                <Link to="/u/login/">Login</Link>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="header_bottom_spacing"></div>
    </div>
  );
}

export default Header;
